import * as actionTypes from '../actions'

const initialState = {
  name: 'Productos más vendidos',
  listCategory: [],
  loading: true
}

const categoryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SEARCH_CATEGORY: {
      return {
        ...state,
        listCategory: action.payload.data
          ? action.payload.data
          : action.payload,
        loading: false
      }
    }
    //momentaneamente mientras se crea el loading de categoria
    case actionTypes.RESET_CATEGORY: {
      return {
        ...state,
        name: action.payload
      }
    }
    case actionTypes.SHOW_LOADING: {
      return {
        ...state,
        loading: true
      }
    }
    case actionTypes.HIDE_LOADING: {
      return {
        ...state,
        loading: false
      }
    }
    case actionTypes.SHOW_CLIENT_ID: {
      return {
        ...state,
        clientId: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default categoryReducer
